import { render } from "./EditAssessment.vue?vue&type=template&id=f0c0f6ce&scoped=true"
import script from "./EditAssessment.vue?vue&type=script&lang=js"
export * from "./EditAssessment.vue?vue&type=script&lang=js"

import "./EditAssessment.vue?vue&type=style&index=0&id=f0c0f6ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0c0f6ce"]])

export default __exports__